import { useEffect, useState } from "react";
import { clear as clearIndexedDB } from "../../../helpers/indexedDB";
import packageJson from "../../../../package.json";

export const useVersionUpdateStatus = () => {
    const [shouldRefresh, setShouldRefresh] = useState(false);
    const [isReloading, setIsReloading] = useState(false);

    useEffect(() => {
        const checkVersionMismatch = (latestVersion, currentVersion) =>
            latestVersion !== currentVersion;

        const loadMeta = async () => {
            try {
                const response = await fetch(`/meta.json?_=${Date.now()}`, {
                    cache: "no-store",
                });
                if (!response || !response.ok) {
                    throw new Error(
                        `Failed to fetch meta.json: HTTP ${response?.status}`
                    );
                }
                const meta = await response.json();
                const latestVersion = meta.version;
                const currentVersion = packageJson.version;
                setShouldRefresh(checkVersionMismatch(latestVersion, currentVersion));
            } catch (error) {
                try {
                    if ("caches" in window) {
                        const cached = await caches.match("/meta.json");
                        if (cached) {
                            const meta = await cached.json();
                            const latestVersion = meta.version;
                            const currentVersion = packageJson.version;
                            setShouldRefresh(
                                checkVersionMismatch(latestVersion, currentVersion)
                            );
                        }
                    }
                } catch (_) {
                } finally {
                    console.warn(
                        "Version check: meta.json not available, skipping network check.",
                        error
                    );
                }
            } finally {
            }
        };

        loadMeta();
    }, []);

    const clearCacheAndReload = async () => {
        if (!navigator.onLine) return;
        setIsReloading(true);
        try {
            localStorage.clear();
            sessionStorage.clear();
            await clearIndexedDB();
            document.cookie.split(";").forEach((c) => {
                document.cookie = c
                    .replace(/^ +/, "")
                    .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
            });
            if ("caches" in window) {
                const cacheNames = await caches.keys();
                await Promise.all(cacheNames.map((name) => caches.delete(name)));
            }
            if ("serviceWorker" in navigator) {
                try {
                    const registrations = await navigator.serviceWorker.getRegistrations();
                    await Promise.all(
                        registrations.map((registration) => registration.unregister())
                    );
                } catch (error) {
                    console.warn("Could not unregister service workers:", error);
                }
            }
        } finally {
            window.location.reload(true);
        }
    };

    return { shouldRefresh, isReloading, clearCacheAndReload };
};

export default useVersionUpdateStatus;


